import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { MainLayout } from '../layouts/MainLayout';
import { CollectorCameraPreview } from './CollectorCameraPreview';
import { WelcomeWidget } from '../components/widget/WelcomeWidget';
import { Collector } from '../models/Collector';
import { API } from '../utils/API';
import { useUIContext } from '../context/UIContext';

type RouterParams = {
  id: string;
}

export const CameraPreview: FC = () => {
  const { id } = useParams<RouterParams>();
  const { loader, toast } = useUIContext();

  const [collector, setCollector] = useState<Collector>();

  const fetchCollectorDetails = async () => {
    if (!id) return;
    loader.showLoader();
    try {
      const response = await API.Users.getCollector(id);
      setCollector(response);
    } catch (error: any) {
      toast.showToast(error.message, 'ERROR');
    } finally {
      loader.hideLoader();
    }
  };

  useEffect(() => {
    if (!id) return;
    fetchCollectorDetails().finally(() => undefined);
  }, [id]);

  return (
    <MainLayout selectedTab="DASHBOARD">
      <WelcomeWidget />
      {collector && <CollectorCameraPreview collector={collector} />}
    </MainLayout>
  );
};
